import { formatNumberDisplayValue, maxDecimalValue } from '@/utils/numberUtil';
import { Translations } from '@/utils/translations/Translations';
export const spanishTranslations: Translations = {
  admin: {
    applicationCyclesCurrent: 'Ciclos de solicitud actuales',
    applicationCyclesHeader: 'Ciclos de solicitud',
    applicationCyclesPast: 'Ciclos de solicitud anteriores',
    applicationCyclesUpcoming: 'Próximos ciclos de solicitud',
    applicationsHeader: 'Solicitudes',
    emailsHeader: 'Correos electrónicos',
    tabEmailActivity: 'Actividad de correo',
    tabSendEmail: 'Enviar correo',
    tabTcowMassApproval: 'Aprobación masiva TCOW',
  },
  address: {
    addAddress2: '+ Apto/Suite/Unidad',
    labelCity: 'Ciudad',
    labelCountry: 'País',
    labelCounty: 'Condado',
    labelState: 'Estado',
    labelStreetAddress: 'Dirección',
    labelStreetAddress2: 'Apto/Suite/Unidad',
    labelZipCode: 'Código postal',
  },
  applicationHeader: {
    headerViewingApplication: 'Visualización de la aplicación para ',
    messageRequiredQuestions: 'Complete todas las preguntas requeridas',
    missingRequiredQuestions: 'Preguntas obligatorias faltantes',
    reviewerComments: 'Comentarios del Revisor',
    standardCompleted: 'Terminé',
    starAwarded: 'Estrella concedida',
    yearsRecognized: (year: number) => `Solicitud para el año ${year} de reconocimiento`,
  },
  applicationPreview: {
    backToAdmin: 'Volver a Admin',
    previewModeMessage:
      'El modo de vista previa está habilitado. Los cambios en esta vista no se guardan.',
    programLabel: 'Programa',
    unknownValue: 'Desconocido',
  },
  applicationBody: {
    approveApplicationButton: 'Aprobar solicitud',
    resubmitButton: 'Reenviar',
    sendBackToApplicantWithComments: 'Devolver la solicitud al solicitante con comentarios',
    starApprovalButton: 'Aprobar estrella',
    starRemovalButton: 'Quitar estrella',
    submitButton: 'Enviar',
    submitMessage: 'Enviando...',
    tooltipApproveSendsToNextReviewStage:
      'Al hacer clic en « Aprobar », la solicitud se envía a la siguiente etapa de revisión.',
    tooltipApproveBeforeSubmit:
      'Asegúrese de que su revisión esté completa antes de hacer clic en « Aprobar ».',
    tooltipApproveWithUnresolvedComments:
      'Resuelva todos los comentarios antes de aprobar la solicitud. Los comentarios sin resolver se encuentran en los estándares marcados en amarillo en la barra de progreso.',
    tooltipNextStandard: 'Siguiente estándar',
    tooltipPreviousStandard: 'Estándar anterior',
    tooltipRequiredQuestions: 'Complete todas las preguntas requeridas primero',
    tooltipSendBackRequiresComment:
      'Ingrese un comentario para esta etapa de revisión antes de devolver la solicitud al solicitante.',
  },
  common: {
    ariaSaved: 'Guardado',
    ariaSaveFailed: 'Error al guardar',
    ariaSaving: 'Guardando',
    buttonPost: 'Publicar',
    buttonReactivate: 'Reactivar',
    buttonResolve: 'Resolver',
    defaultConfirmationModalText: {
      header: 'Confirmar acción',
      confirmationMessage: '¿Está seguro de que desea continuar? Esta acción no se puede deshacer.',
      confirmationButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar',
      successMessage: '¡Eliminación exitosa!',
    },
    buttonSaving: 'Guardando...',
    buttonSave: 'Guardar',
    buttonDelete: 'Eliminar',
    buttonUpdate: 'Actualizar',
    characterCountRemaining: (remaining: number, max: number) =>
      `${remaining}/${max} caracteres restantes`,
    commentResolved: 'Comentario resuelto',
    error: 'Error',
    genericError: 'Ocurrió un error. Por favor, inténtelo de nuevo.',
    messageCommentAddedSuccessfully: '¡Comentario agregado correctamente!',
    messageCommentAddFailed: 'No se pudo agregar el comentario',
    messageCommentCannotBeEmpty: '¡El comentario no puede estar vacío!',
    messageCommentTooLong: '¡El comentario es demasiado largo!',
    messageGrowthAwardApprovalSuccess: '¡Aprobación exitosa!',
    messageGrowthAwardApproveProblem:
      'Hubo un problema al aprobar el premio Growth Award. Inténtelo de nuevo más tarde.',
    messageGrowthAwardApproving: 'Aprobando Growth Award ...',
    messageGrowthAwardCategoriesFetchError: 'Error al obtener las categorías de Growth Award.',
    messageGrowthAwardCommentRequired:
      'Ingrese un comentario antes de devolver la solicitud al solicitante.',
    messageGrowthAwardReturnSuccess: '¡Devolución exitosa!',
    messageGrowthAwardSendBackProblem: 'Hubo un problema al devolver la solicitud.',
    messageGrowthAwardSendingBack: 'Enviando Growth Award de regreso al solicitante...',
    messageGrowthAwardSubmitted: '¡Solicitud de Growth Award enviada!',
    messageGrowthAwardSubmitting: 'Enviando Growth Award ...',
    messageGrowthAwardSubmitProblem: 'Hubo un problema al enviar Growth Award.',
    noMatch: 'No se encontraron resultados.',
    placeholderPostComment: 'Publicar un comentario',
    previewInputPlaceholder: 'Entrada de vista previa (no se guarda)',
    previewWorkflowSpecificDataNotice:
      'Esta pregunta usa datos específicos del flujo de trabajo en producción. El modo de vista previa solo captura texto local y no llama a las API.',
    buttonContinue: 'Continuar',
    buttonCancel: 'Cancelar',
    buttonClose: 'Cerrar',
    requiredIndicatorTitle: 'requerido',
    statusApplicationApproved: 'Solicitud aprobada',
    statusApplicationReturned: 'Solicitud devuelta',
    statusApplicationSubmitted: 'Solicitud enviada',
    statusApproving: 'Aprobando...',
    statusReturning: 'Devolviendo...',
    statusUpdating: 'Actualizando ...',
    tooltipSubmitGrowthAward: 'Haga clic para enviar la solicitud de Growth Award.',
    tooltipRetrySave: 'Reintentar guardado',
    tooltipSaveFailed: 'Error al guardar',
  },
  contact: {
    confirmationModal: {
      header: 'Eliminar contacto',
      confirmationMessage:
        '¿Está seguro de que desea eliminar este contacto? Esta acción no se puede deshacer.',
      confirmationButtonText: 'Eliminar contacto',
      successMessage: '¡Contacto eliminado con éxito!',
    },
    buttonAdd: 'Añadir nuevo contacto',
    buttonChange: 'Cambiar contacto',
    buttonCreate: 'Seleccione o cree un nuevo contacto',
    buttonSave: 'Guardar contacto',
    buttonUpdate: 'Actualizar contacto',
    createContact: 'Crear nuevo contacto',
    editContact: 'Editar contacto',
    editWarning: (appYear: string) =>
      `Estás a punto de modificar los detalles de un contacto existente. Estos cambios se actualizarán en todas partes donde se use este contacto en las aplicaciones de ${appYear}.`,
    invalidEmail: 'Por favor, ingrese una dirección de correo electrónico válida.',
    invalidZipCode: 'Por favor, ingrese un código postal válido.',
    invalidPhoneNumber: 'Número de teléfono no válido',
    requiredFieldSuffix: 'es obligatorio',
    labelCity: 'Ciudad',
    labelCountry: 'País',
    labelEmail: 'Correo electrónico',
    labelFirstName: 'Nombre',
    labelLastNameLabel: 'Apellido',
    labelName: 'Nombre',
    labelPhoneNumber: 'Número de teléfono',
    labelStreetAddress2Label: 'Dirección 2',
    labelStreetAddressLabel: 'Dirección',
    labelTitle: 'Título profesional',
    labelWhatsApp: 'Whatsapp o número de teléfono móvil alternativo',
    labelZipCode: 'Código postal',
    messageContactRemoved: '¡Contacto eliminado!',
    messageContactSaveFailed: 'No se pudo guardar el contacto.',
    messageMaximum: 'Ha alcanzado el número máximo de contactos para esta sección.',
    messageSaved: '¡Contacto Guardado!',
    placeHolderPhoneNumber: 'Número de teléfono',
  },
  dashboard: {
    accessToolkit: 'Acceder al kit de herramientas',
    accessToolkitPendingApproval: 'Disponible una vez que su solicitud sea aprobada',
    download: 'Descargar',
    downloadTooltip: 'Descargar e imprimir solicitud',
    fieldApplication: 'Solicitud',
    fieldApplicationCycle: 'Ciclo de Solicitud',
    fieldStatus: 'Estado',
    fieldSubmittedBy: 'Presentado por',
    growthAwardCardHeader: 'SOLICITAR PREMIO DE CRECIMIENTO',
    growthAwardCardPendingLabel: (programName: string) =>
      `La solicitud del Premio de Crecimiento puede iniciarse una vez que se haya enviado su solicitud de ${programName}.`,
    growthAwardCardStartButton: 'Iniciar Premio de crecimiento',
    labelApplication: 'SOLICITUD',
    labelCreateApplication: 'Crear nueva solicitud',
    labelPastApplications: 'Solicitudes',
    messageCreateApplication: 'Creando una nueva solicitud ...',
    messageNoApplications: 'Sin solicitudes',
    portalClosedInformation: (latestAppCycleYear: string, nextOpenDate?: string | null) =>
      `La solicitud para el ciclo ${
        latestAppCycleYear != null ? latestAppCycleYear + ' ' : ''
      }está actualmente cerrada. ${
        nextOpenDate != null ? `Las solicitudes se abrirán el ${nextOpenDate}. ` : ''
      }Gracias.`,
    selectPartner: 'Seleccione un socio',
    stateQuestionsCardHeader: 'SU ESTADO SOLICITA INFORMACION ADICIONAL',
    stateQuestionsCardPendingLabel:
      'Las preguntas especificas del estado pueden iniciarse una vez que se haya enviado una solicitud de Tree City USA.',
    stateQuestionsCardStartButton: 'Iniciar preguntas de estado',
    viewApplication: 'Ver solicitud',
    viewApplicationHelperTextEnabled: 'Ver solicitud',
    viewApplicationHelperTextDisabled: 'Solicitud no disponible',
    viewApplicationButton: 'Ver solicitud',
    growthAwardHeader: 'Premio de crecimiento',
    growthAwardPendingLabel: 'Pendiente - No se puede iniciar',
    growthAwardStartButton: 'Iniciar Premio de crecimiento',
    stateQuestionsHeader: 'Preguntas de estado',
    stateQuestionsPendingLabel: 'Pendiente - No se puede iniciar',
    stateQuestionsStartButton: 'Iniciar preguntas de estado',
    messageCreateApplicationError:
      'Ocurrió un error al crear la solicitud. Por favor, inténtelo de nuevo.',
    messageNoCycleFound:
      'No se encontró ningún ciclo de solicitud. Por favor, inténtelo de nuevo más tarde.',
    messageFetchApplicationsError:
      'No se pudieron cargar las solicitudes. Por favor, inténtelo de nuevo o actualice la página.',
    loadingText: 'Cargando...',
    exportEmailLabel: 'Ingrese su correo electrónico para recibir un enlace a su descarga',
    exportEmailAlreadyAdded: (email: string) =>
      `'${email}' ya fue agregado a la lista de destinatarios de exportación.`,
    exportEmailPlaceholder: 'Correo electrónico',
    exportErrorMessage: 'Ocurrió un error al generar la descarga. Por favor, inténtelo de nuevo.',
    exportGenerating: 'Generando descarga...',
    exportGenerateCsv: 'Generar CSV',
    exportIncludeQuestionResponses: 'Incluir respuestas a preguntas',
    exportInvalidEmailAddress: (email: string) =>
      `'${email}' no es una dirección de correo válida.`,
    exportMaxEmailsWarning:
      'Solo se permiten 5 correos electrónicos por día. Por favor, inténtelo de nuevo mañana.',
    exportModalTitle: 'Generar descarga',
    exportOptionalParams: 'Parámetros opcionales',
    exportRequiredParams: 'Parámetros requeridos',
    exportSelectApplicationType: 'Seleccione el tipo de solicitud',
    exportSelectCounty: 'Seleccione el condado',
    exportSelectPartner: 'Seleccione el socio',
    exportSelectProgram: 'Seleccione el programa',
    exportSelectState: 'Seleccione el estado',
    exportSuccessMessage: '¡Descarga generada! Por favor revise su correo electrónico.',
    exportTypeGrowthAward: 'Premio de crecimiento',
    exportTypeMainApplications: 'Solicitudes principales',
    exportTypeStateQuestions: 'Preguntas de estado',
  },
  dataUpload: {
    confirmationModal: {
      header: 'Eliminar archivo adjunto',
      confirmationMessage:
        '¿Está seguro de que desea eliminar este archivo adjunto? Esta acción no se puede deshacer.',
      confirmationButtonText: 'Eliminar archivo adjunto',
      successMessage: '¡Archivo adjunto eliminado con éxito!',
    },
    errorURL: 'Envíe una URL válida',
    helperSelectFile:
      'Haga clic en Seleccionar para buscar y elegir un archivo en su computadora. Haga clic en Guardar para adjuntarlo a su aplicación. Asegúrese de que su nombre de archivo sea único. Formatos de archivo comprimidos, p. .zip, no son compatibles.',
    helperUrl:
      'Si comparte una URL, compruebe que se trata de un sitio web y no un enlace a una plataforma para compartir documentos (p. ej., Google Docs o Dropbox). Si es una URL, asegúrese de incluir http:// o https:// como parte de la URL. Haga clic en Guardar para adjuntarlo a su solicitud.',
    labelAddFile: 'Agregar archivo',
    labelEventProof: 'Adjuntar prueba de la',
    labelFile: 'Archivo',
    labelURL: 'URL',
    labelSave: 'Guardar',
    labelSaving: 'Guardando',
    labelSelectFile: 'Seleccionar',
    labelUpload: 'Subiendo',
    messageDownload: 'Haga clic para descargar PDF',
    messageFailed: 'Error de carga.',
    messageSuccess: '¡Subida exitosa!',
    placeholderURL: 'Escribe una URL',
    errorFileSize: 'La tamaño del archivo excede el límite de 25MB.',
    errorFileTypeUnsupported:
      'Este tipo de archivo no es compatible. Cargue un archivo que no sea .zip.',
    warningDuplicateFileSkipped:
      'Se detectó un nombre de archivo duplicado. Los archivos duplicados fueron omitidos.',
    warningDuplicateUrlExists: 'Esta URL ya fue agregada.',
    labelTryAgain: 'Intentar de nuevo',
    labelUploadedFile: 'Archivo cargado',
    labelSavedUrl: 'URL guardada',
    labelGetPdfSummary: 'Obtener resumen en PDF',
    tooltipClearError: 'Borrar error',
    tooltipOpen: 'Abrir',
    tooltipDownload: 'Descargar',
    tooltipDelete: 'Eliminar',
    ariaClearUploadError: 'Borrar error de carga',
    ariaOpenAttachment: 'Abrir archivo adjunto',
    ariaOpenUrlAttachment: 'Abrir URL adjunta',
    ariaDownloadAttachment: 'Descargar archivo adjunto',
  },
  deadlineBanner: {
    deadlineText: 'PLAZO DE SOLICITUD',
    stateReviewDeadlineText: 'Fecha limite de revision estatal',
  },
  decimalQuestion: {
    maxValueExceeded: `Su entrada debe ser un número entre 0 y ${formatNumberDisplayValue(
      maxDecimalValue.toString(),
      'decimal'
    )}.`,
  },
  event: {
    confirmationModal: {
      header: 'Eliminar contacto',
      confirmationMessage:
        '¿Está seguro de que desea eliminar este contacto? Esta acción no se puede deshacer.',
      confirmationButtonText: 'Eliminar contacto',
      successMessage: '¡Evento eliminado con éxito!',
    },
    buttonAddEvent: 'Agregar',
    celebration: 'Celebracion',
    dateRangeError: 'Seleccione una fecha entre {{minDate}} y {{maxDate}}.',
    eventName: 'Nombre del evento',
    helperEvent:
      'Para agregar otro evento, haga clic en el botón Agregar a continuación. Para eliminar un evento adicional, haga clic en el botón borrar en el evento (debe tener al menos un evento).',
    labelName: 'Durante el año ¿Cuándo celebró su ciudad a los árboles y bosques urbanos?',
    labelSubType: 'Tipo de evento',
    labelSubTypeOther: 'por favor explique',
    messageDelete: 'Borrando...',
    messageSaved: '¡Evento guardado!',
    other: 'Otro',
    summary: 'Resumir el',
    tooltipDelete: 'Haga clic para eliminar este evento.',
    treeDay: 'Dia del arbol',
    type: 'Tipo',
  },
  header: {
    application: 'SOLICITUD',
    dashboard: 'PANEL',
    error: 'Error',
    inactive: 'Usuario inactivo',
    myaccount: 'Información de la cuenta',
    mycontact: 'Información de contacto',
    pending: 'PENDIENTE',
    pendingMessage:
      'Su cuenta está esperando validación. Podrá continuar una vez que un administrador apruebe su solicitud.',
    signedInAs: 'Registrado como',
    signup: 'INSCRIBIRSE',
    tooltipDashboard: 'Volver al panel',
    tooltipLanguage: 'Cambiar idioma',
    tooltipHelp: 'Ayuda',
    tooltipMyAccount: 'Mi cuenta',
    tooltipSignOut: 'Desconectar',
    tooltipUserManagement: 'Gestión de usuarios',
    usermanagement: 'GESTIÓN DE USUARIOS',
    instructionsTitle: 'Instrucciones',
    growthaward: 'PREMIO DE CRECIMIENTO',
    statequestions: 'PREGUNTAS DE ESTADO',
    tooltipStopImpersonation: 'Dejar de personificar',
  },
  integerQuestion: {
    invalidInteger: 'Su entrada debe estar entre 0 y 99,999,999.',
    labelSum:
      'La suma de árboles jóvenes y plántulas debe ser menor o igual al total de árboles plantados.',
  },
  multiCheckbox: {
    helper: 'Seleccione al menos uno',
  },
  multiCheckbox3: {
    helperMaximum: 'No más de 3 opciones',
  },
  myaccount: {
    accountSettings: 'Configuración de la cuenta',
    characterlimit: (charLimit: number) => `Límite de ${charLimit} caracteres`,
    errorHelperText: 'Por favor complete todos los campos obligatorios',
    emailNewAccountHelperText:
      'Para registrar una nueva dirección de correo electrónico, deberá crear una cuenta nueva.',
    myAccount: 'Mi cuenta',
    partnerDetails: (partnerName: string) => `Detalles de ${partnerName}`,
    preferredlanguage: '¿Cuál es tu idioma preferido?',
    primaryContactHeader: 'Información de contacto principal',
    titlerequired: 'Título obligatorio',
    updatePrimaryContactError: 'Error al actualizar el contacto principal',
    updatePrimaryContactSuccess: 'Contacto principal actualizado',
    updateUserContactSuccess: 'Contacto de usuario actualizado',
    updateUserContactError: 'Error al actualizar el contacto de usuario',
    unsavedChangesBody: 'Tiene cambios no guardados. ¿Desea descartarlos y navegar lejos?',
    unsavedChangesTitle: 'Cambios no guardados',
    buttonKeepEditing: 'Continuar editando',
    buttonDiscardChanges: 'Descartar cambios',
    shippingContactHeader: 'Información de contacto de envío',
    tabAccountSettings: 'Configuración de la cuenta',
    tabPrimaryContact: 'Contacto principal',
    tabShippingAddress: 'Dirección de envío',
    errorUpdatingShippingContact: 'Error al actualizar el contacto de envío',
    shippingContactUpdated: 'Contacto de envío actualizado',
  },
  partner: {
    other: 'Otro',
  },
  partnerUpdateModal: {
    saveAwards: 'Guardar premios',
    saveContacts: 'Guardar contactos',
    savePartnerInfo: 'Guardar información del socio',
    tabContacts: 'Contactos',
    tabPartnerInfo: 'Información del socio',
    tabYearsAwarded: 'Años premiados',
    titleEditPartnerDetails: 'Editar detalles del socio',
    tooltipError: 'Error',
    tooltipHasUnsavedChanges: 'Tiene cambios sin guardar',
    tooltipSaved: 'Guardado',
    tooltipSaving: 'Guardando',
  },
  profileMenu: {
    addAccount: 'Agregar cuenta',
    addAccountTooltip:
      'Esto es para organizaciones que participan en múltiples programas o tienen múltiples ubicaciones y necesitan crear cuentas separadas para cada una.',
    manageAccount: 'Gestionar cuenta',
    myAccount: 'Mi cuenta',
    signOut: 'Cerrar sesión',
    admin: 'Administración',
    userManagement: 'Gestión de usuarios',
  },
  percentQuestion: {
    invalidPercent: 'Su entrada debe ser un número entre 0 y 100.',
  },
  signature: {
    buttonClear: 'Limpiar',
    messageSaved: '¡Firma guardada!',
    terms: 'Términos y condiciones',
    tooShortError: 'La firma es demasiado corta. Por favor, dibuje una firma más larga.',
  },
  submitConfirmation: {
    title: 'Solicitud enviada',
    message: 'Gracias. Su solicitud se ha enviado y ahora está pendiente de revisión.',
    reviewApplication: 'Revisar solicitud',
    backToDashboard: 'Volver al panel',
  },
  signup: {
    buttonSubmit: 'ENTREGAR',
    checkContactShipping: 'Igual que la dirección de contacto principal',
    checkIncludeInDirectory:
      'SI SE APRUEBA MI SOLICITUD, NO DESEO QUE SE INCLUYAN MI NOMBRE NI MI CORREO ELECTRÓNICO EN LA PÁGINA DEL DIRECTORIO DEL CENTRO DE RECURSOS PARA SOCIOS DE LAS CIUDADES ARBOLADAS DEL MUNDO (SOLO DISPONIBLE PARA OTRAS CIUDADES A LAS QUE SE HAYA CONCEDIDO ESTE RECONOCIMIENTO).',
    choiceNo: 'No',
    choiceSelect: 'Seleccionar',
    choiceYes: 'Sí',
    countrySelect: 'Seleccionar su País',
    fuzzyMatchContinue: (partnerTerm: string) => `Continuar creando un nuevo ${partnerTerm}`,
    fuzzyMatchMessage:
      'Encontramos algunos socios existentes con nombres similares en su estado. ¿Se refería a alguno de estos?',
    fuzzyMatchSelect: 'Seleccionar',
    fuzzyMatchTitle: 'Socios similares encontrados',
    errorMessageEnd: 'Verifique los valores y vuelva a ingresarlos si es necesario.',
    errorMessageStart:
      'Hubo un problema con su formulario. Las siguientes preguntas no tienen un valor válido:',
    errorPartnerHeader: 'Detalles de la Ciudad',
    errorPrimaryContactHeader: 'Detalles del contacto principal',
    errorShippingContactHeader: 'Detalles de envío',
    headerAddAccount: 'Agregar cuenta',
    headerExistingPartnerDetails: 'Selecciona tu ciudad',
    headerLabel: 'Información',
    headerPartnerDetails: 'Nuevos detalles de la ciudad',
    headerPrimaryContact: 'Información de contacto principal',
    headerProgram: 'Portal de Reconocimiento de Programas',
    headerSelectProgram: '¿Qué estás solicitando?',
    headerShipping: 'Dirección de envío predeterminada',
    headerSocialMedia: 'Canales de redes sociales para su ',
    helperCityError: 'Ciudad requerida',
    helperEmailError: 'Correo electrónico requerido',
    helperNameError: 'Nombre requerido',
    helperShippingCityError: 'Ciudad requerida',
    helperShippingStreetAddressError: 'Dirección requerida',
    helperShippingZipCodeError: 'Por favor ingrese un código postal de envío válido',
    helperStreetAddressError: 'Dirección requerida',
    helperZipCode: 'Ingrese valores numéricos',
    helperZipCodeError: 'Código postal requerido',
    labelAppliedToADF: (partnerTerm: string, programName: string) =>
      `No encontré su ${partnerTerm} o es la primera vez que su ${partnerTerm} solicita el reconocimiento ${programName}. Haga clic para iniciar una nueva ${partnerTerm}.`,
    labelCategory: '¿Qué categoría describe mejor su ',
    labelCity: 'Ciudad',
    labelGenericEmail:
      'Correo electrónico genérico para el consistorio (Ejemplo: forester@cityname.com)',
    labelName: 'Nombre',
    labelPhoneNumber: 'Número de teléfono de la ',
    labelShippingCity: 'Ciudad',
    labelShippingCountry: 'País',
    labelShippingStreetAddress: 'Dirección',
    labelShippingStreetAddress2: 'Dirección 2',
    labelShippingZipCode: 'Código Postal',
    labelSubCategoryOther: 'Por favor especifica:',
    labelTitle: 'Título profesional',
    labelZipCode: 'Código Postal',
    messageSubmissionError: 'Error al enviar el formulario de admisión.',
    messageSubmissionSuccess: 'Formulario de admisión enviado con éxito.',
    partnerNotFoundHelperText: (partnerTerm: string) =>
      `No se encontró ${partnerTerm} - Marque la casilla a continuación para iniciar un nuevo ${partnerTerm}`,
    partnerSelect: 'Seleccionar su ',
    required: 'número requerido',
    selectProgram: 'Seleccionar programa',
    subHeaderExistingPartnerDetails: (partnerTerm: string, programName: string) =>
      `Si su ${partnerTerm} ha solicitado el reconocimiento de ${programName} en el pasado, busque su ${partnerTerm} utilizando este formulario. Si no lo encuentra, haga clic en la casilla de verificación a continuación para comenzar una nueva ${partnerTerm}.`,
    subHeaderPartnerDetails:
      'Nota: si va a solicitar varias ubicaciones, complete lo siguiente para una ubicación. Tendrá la oportunidad de agregar ubicaciones adicionales más adelante en el proceso.',
    tooltipSubmit: 'Haga clic para enviar el formulario de admisión.',
  },
  userLoadError: {
    contactUs: 'Contáctenos',
    message:
      'Inténtelo de nuevo. Si el problema continúa, contáctenos e incluya la referencia que aparece a continuación.',
    referenceLabel: 'Referencia',
    signOut: 'Cerrar sesión',
    title: 'No pudimos cargar su cuenta.',
    tryAgain: 'Reintentar',
  },
  userManagement: {
    removeReviewerAssignmentConfirmationModal: {
      header: 'Eliminar asignación de revisor',
      confirmationMessage:
        '¿Está seguro de que desea eliminar esta asignación de revisor? Esta acción no se puede deshacer.',
      confirmationButtonText: 'Eliminar asignación',
      successMessage: '¡Asignación de revisor eliminada con éxito!',
    },
    snackbarError: 'edición fallida',
    snackbarSuccess: 'actualizado exitosamente',
  },
};
